import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="28" height="28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M17.5 9.333v9.334H5.833V9.333H17.5zM18.667 7h-14A1.17 1.17 0 003.5 8.167v11.666A1.17 1.17 0 004.667 21h14a1.17 1.17 0 001.166-1.167V15.75l4.667 4.667V7.583l-4.667 4.667V8.167A1.17 1.17 0 0018.667 7z" fill="#54585D" /></svg>);